import { createStore } from 'vuex'
  const $storeUser = localStorage.getItem('user_zgh');
export default createStore({
  state: {
    user_zgh: $storeUser ? JSON.parse($storeUser) : null,
    client_zgh:null,
    panier_zgh:null
  },
  getters: {
    //!On peut faire: currentUser: state => state.user
    currentUser(state) {
      return state.user_zgh;
    }
  },
  mutations: {
    setUser(state, user_zgh) {
      state.user_zgh = user_zgh;
      localStorage.setItem('user_zgh', JSON.stringify(user_zgh));
    },
    setClient(state, client_zgh) {
      state.client_zgh = client_zgh;
      localStorage.setItem('client_zgh', JSON.stringify(client_zgh));
    },
    setPanier(state, panier_zgh) {
      state.panier_zgh = panier_zgh;
      localStorage.setItem('panier_zgh', JSON.stringify(panier_zgh));
    },
    removeUser(state) {
      state.user_zgh = null;
      localStorage.removeItem('user_zgh');
    },
    removeClient(state) {
      state.client_zgh = null;
      localStorage.removeItem('client_zgh');
    },
    removePanierZgh(state) {
      state.panier_zgh = null;
      localStorage.removeItem('panier_zgh');
    },
  },
  actions: {
  },
  modules: {
  }
})
